// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3v5OT","tab":"Tabs_tab__2j69e","tabActive":"Tabs_tabActive__2Wy0R"};